/**
 * PitchBook Admin API
 * PitchBook Admin OpenAPI specification
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {createAction} from '@reduxjs/toolkit';
import {ApiMethods, ConcurrentStrategies} from '@pb/middleware-api';
import {PayloadData} from '../types';
import type {Error} from '../models/Error';
import type {UserShortInfo} from '../models/UserShortInfo';

export interface GetAccountTemplateUsers$Request {
    accountId?: number;
    onlyActive?: boolean;
}

export interface GetAccountTemplateUsers$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const getAccountTemplateUsersRequest = createAction<PayloadData<void, GetAccountTemplateUsers$Request>>('GET_ACCOUNT_TEMPLATE_USERS__GET_ACCOUNT_TEMPLATE_USERS__REQUEST');
export const getAccountTemplateUsersSuccess = createAction<PayloadData<Array<UserShortInfo>, GetAccountTemplateUsers$Request>>('GET_ACCOUNT_TEMPLATE_USERS__GET_ACCOUNT_TEMPLATE_USERS__SUCCESS');
export const getAccountTemplateUsersFailure = createAction<PayloadData<Error, GetAccountTemplateUsers$Request, true>>('GET_ACCOUNT_TEMPLATE_USERS__GET_ACCOUNT_TEMPLATE_USERS__FAILURE');

export const getAccountTemplateUsersActions = [
    getAccountTemplateUsersRequest,
    getAccountTemplateUsersSuccess,
    getAccountTemplateUsersFailure
] as const;

/**
 * @param {number} [meta.accountId] Account id
 * @param {boolean} [meta.onlyActive]
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const getAccountTemplateUsers = (meta: GetAccountTemplateUsers$Request, config?: GetAccountTemplateUsers$Config) => {
    const TRANSPORT_GET_PARAMS = {
        accountId: meta.accountId,
        onlyActive: meta.onlyActive,
    };
    return {
        CALL_API: {
            types: getAccountTemplateUsersActions,
            method: ApiMethods.GET,
            endpoint: `/web-api/accounts/settings/template-users`,
            TRANSPORT_GET_PARAMS,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

